<template>
  <div class="main-content">
    <Header />
    <div class="side-nav">
      <Sidebar :item="item" :payroll="payroll" />
    </div>
    <div class="content">
      <div class="quickpay">
        <div class="virtual-container">
          <p>Fund Your Wallet</p>
          <div>
            <div class="quickpay__alert--msg" v-if="lessFund">
              <div class="quickpay__alert--img">
                <img src="./../../../assets/images/warning.png" alt />
              </div>
              <div class="quickpay__alert--text">
                Your wallet balance is insufficient to process this transaction.
                Kindly fund your wallet.

                <div v-if="virtualAccountData">
                  <div class="wallet-fund-input pr-ss0">
                    <div class="">
                      <div class="virtual-card">
                        <div class="virtual-text-block">
                          <p class="virtual-card-heading">BANK NAME</p>
                          <p class="virtual-card-text">
                            {{ virtualAccountData.bank_name }}
                          </p>
                        </div>
                        <div class="virtual-text-block">
                          <p class="virtual-card-heading">ACCOUNT NUMBER</p>
                          <p class="virtual-card-text">
                            {{ virtualAccountData.account_number }}
                          </p>
                        </div>
                        <div class="virtual-text-block">
                          <p class="virtual-card-heading">ACCOUNT NAME</p>
                          <p class="virtual-card-text">
                            {{ virtualAccountData.account_name }}
                          </p>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="quickpay__form--btn" v-if="loading">
                  <WhiteLoader />
                </div> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="quickpay__alert--success" v-if="justFunded">
              <div class="quickpay__alert--img">
                <img src="./../../../assets/images/happiness.svg" alt />
              </div>
              <div class="quickpay__alert--text">
                Yass; Your wallet has been funded
              </div>
            </div>

            <div class="quickpay__amount">
              <div class="quickpay__amount--balance">
                <span>Wallet Balance</span>
                <p>
                  &#8358;{{ parseInt(currentBalance, 10) | addKoboToValue }}
                </p>
              </div>
              <div class="quickpay__amount--current">
                <span>Current Payroll Amount</span>
                <p>
                  &#8358;{{ parseInt(payrollBalnace, 10) | addKoboToValue }}
                </p>
              </div>
              <div class="quickpay__amount--available">
                <span>Transaction Cost</span>
                <p>
                  &#8358;{{ parseInt(transactionCost, 10) | addKoboToValue }}
                </p>
              </div>
            </div>
            <p v-if="justFunded">
              Now that your account has been funded, you can pay now
            </p>
            <div class="quickpay__err">
              <p v-if="serverErr">An error occured. Please try again.</p>
              <p v-if="lessFundText">
                Your don't have enough money to make payment. Please kindly fund
                your wallet.
              </p>
              <p v-if="dataFetchError">
                Unable to fetch wallets data. Please try again.
              </p>
              <p v-if="dataSaveError">{{ dataSaveError }}</p>
              <div v-if="serverErrors">
                <p v-for="(value, name, index) in serverErrors" :key="index">
                  {{ value[0] }}
                </p>
              </div>
            </div>
            <div class="quickpay__btn" @click="payNow" v-if="!payloader">
              Pay Now
            </div>
            <div class="quickpay__btn" v-if="payloader">
              <WhiteLoader />
            </div>
            <div class="quickpay__image">
              <img src="./../../../assets/images/beach.png" alt />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="paynow" v-if="modal">
      <div>
        <div>
          <p>
            <span @click="closeModal">
              <font-awesome-icon icon="times" />
            </span>
          </p>
          <div>
            <div class="paynow__image">
              <img src="./../../../assets/images/success.svg" alt="success" />
            </div>
            <span>Successful</span>
            <div class="paynow__amount">
              <p>Your payroll is being processed.</p>
            </div>

            <div class="paynow__btn">
              <div class="paynow__btn--confirm" @click="seeTransactions">
                See Transactions
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import { addKoboToValue } from "../../../util/filters";
import WhiteLoader from "../../partials/white-loader";

export default {
  name: "OnetimeUpload",
  components: {
    Header,
    Sidebar,
    WhiteLoader,
  },
  data() {
    return {
      item: "quick",
      payroll: "payroll",
      modal: false,
      previewData: "",
      lessFund: false,
      lessFundErr: false,
      justFunded: false,
      lessFundText: false,
      dataSaveError: "",
      dataFetchError: false,
      serverErrors: null,
      loading: false,
      currentBalance: null,
      payrollBalnace: null,
      payloader: false,
      serverErr: false,
      totalCost: null,
      companyDetails: null,
      transactionCost: 0,
      newPayrollId: "",
      virtualAccountData: null,
    };
  },
  methods: {
    fetchVirtualAccount() {
      this.loading = true;
      this.$http
        .get(types.FETCH_VIRTUAL_ACCOUNT_API)
        .then((resp) => {
          const { account_name, account_number } = resp.data.data;
          const isEmpty = account_name === "" && account_number === "";
          if (isEmpty) {
            this.virtualAccountData = null;
          } else {
            this.virtualAccountData = resp.data.data;
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },

    payNow() {
      this.dataSaveError = null;
      this.lessFundErr = false;
      this.serverErr = false;
      this.lessFundText = false;
      this.lessFund = false;

      if (this.payrollBalnace > this.currentBalance) {
        this.lessFundErr = true;
        this.justFunded = false;
        this.lessFundText = true;
        this.lessFund = true;
        return;
      }

      if (Object.keys(this.$store.state.onetime).length !== 0) {
        const payroll_id = this.previewData.payroll_id;
        const type = "one-off";

        this.payloader = true;

        this.$http
          .post(types.PAYROLL_SUBMIT, {
            payroll_id: payroll_id,
            type: type,
          })
          .then((resp) => {
            this.newPayrollId = resp.data.data.payroll_uuid;

            if (resp.data.status) {
              this.modal = true;
            }
            this.payloader = false;
          })
          .catch((err) => {
            if (err.response.status === 400) {
              this.dataSaveError = err.response.data.message;
            } else {
              this.serverErr = true;
            }
            this.payloader = false;
          });

        return;
      }
      this.$router.push("/onetime-upload");
    },


    getCompanyData() {
      let user = this.$store.getters.currentAuthUser;
      this.$http
        .get(`${types.COMPANY_GET_API}/${user.employees.company_id}`)
        .then((resp) => {
          this.companyDetails = resp.data.data;
          this.getWalletBalance();
        });
    },
    getWalletBalance() {
      this.$http
        .get(`${types.COMPANY_WALLET}/${this.companyDetails.wallet_number}`)
        .then((resp) => {
          this.currentBalance = resp.data.data.balance;
          this.previewData.wallet_balance = this.currentBalance;
          this.loading = false;
          this.justFunded = true;

          if (this.payrollBalnace > this.currentBalance) {
            this.lessFundErr = true;
            this.lessFund = true;
          }
        })
        .catch((err) => {
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },

    showModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
      this.$router.push("/onetime-upload");
    },
    seeTransactions() {
      this.modal = false;
      this.$router.push({
        name: "payrollDetails",
        params: { id: this.newPayrollId },
      });
    },
  },
  created() {
    if (Object.keys(this.$store.state.onetime).length !== 0) {
      this.previewData = this.$store.state.onetime;

      this.transactionCost = this.previewData.transaction_cost.total_cost;

      this.currentBalance = this.previewData.wallet_balance;
      this.payrollBalnace = this.previewData.total_payroll;

      if (this.payrollBalnace > this.currentBalance) {
        this.lessFund = true;
      }
      return;
    }
    this.$router.push("/onetime-upload");
  },
  mounted() {
    this.fetchVirtualAccount();
  },

  filters: {
    addKoboToValue,
  },
};
</script>

<style lang="scss" scoped>
.main-content {
  display: flex;
  // height: 100vh;
  // overflow: hidden;

  .side-nav {
    width: 14rem;
    height: 100vh;
    margin-top: 7rem;

    @media (max-width: 768px) {
      display: none;
    }
  }

  .content {
    margin-top: 4rem;
    background: #fbfafa;

  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
    }

  }
}

.quickpay {
  background-color: #fbfafa;
  padding-top: 4rem;
  padding-bottom: 8rem;
  padding-left: 3rem;
  padding-right: 3rem;
  min-height: 50rem;

  > div {
    > p {
      font-size: 1.5rem;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
      border-bottom: 1px solid #caced5;
    }

    > div {
      > .quickpay__form {
        overflow: hidden;
        margin: 20px 0;

        > div {
          width: 300px;
          float: right;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;

          > .quickpay__form--input {
            width: 60%;
            height: 40px;
            border: solid 1px #caced5;
            background-color: #ffffff;
            overflow: hidden;
            position: relative;

            > input {
              width: 100%;
              height: 40px;
              background-color: #fff;
              border: 0;
              outline: 0;
              padding-left: 42px;
              padding-right: 5px;
              font-size: 1rem;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.16;
              letter-spacing: normal;
              color: #000000;
            }

            > div {
              position: absolute;
              top: 0;
              left: 0;
              width: 40px;
              height: 40px;
              border-right: solid 1px #caced5;
              background-color: #fbfafa;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;
              font-size: 1rem;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.16;
              letter-spacing: normal;
              color: #000000;
            }
          }

          > .quickpay__form--btn {
            width: 40%;
            height: 40px;
            border-radius: 2px;
            background-color: #5099de;
            font-size: 1rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            cursor: pointer;
          }
        }
      }

      > .quickpay__alert--msg {
        max-width: 50rem;
        margin: 2rem auto 3rem auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 #fff9f0;
        border: solid 2px #ffe7bd;
        background-color: #fff9f0;
        padding: 0.5rem 1rem;
        align-items: baseline;

        > .quickpay__alert--img {
          width: 3rem;
          height: 2rem;

          > img {
            width: 2rem;
          }
        }

        > .quickpay__alert--text {
          font-size: 1rem;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
        }
      }

      > .quickpay__alert--success {
        max-width: 20rem;
        margin: 3rem auto 4rem auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 #fff9f0;
        border: solid 2px #5099de;
        background-color: rgba(237, 249, 247, 0.5);
        padding: 1rem 1.5rem;

        > .quickpay__alert--img {
          width: 4rem;

          > img {
            width: 2rem;
          }
        }

        > .quickpay__alert--text {
          font-size: 1rem;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
        }
      }

      > .quickpay__amount {
        max-width: 60rem;
        padding: 10px 0;
        border-radius: 2px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        background-color: #ffffff;
        margin: 30px auto 0 auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        text-align: center;

        > .quickpay__amount--balance {
          width: 33.3333333%;
          padding: 10px 0;
          border-right: 1px dashed rgba(0, 0, 0, 0.2);

          > span {
            font-size: 1rem;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.17;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
          }

          > p {
            font-size: 1.6rem;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.18;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
            margin-top: 20px;
          }
        }

        > .quickpay__amount--current {
          padding: 10px 0;
          width: 33.3333333%;

          > span {
            font-size: 14px;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.17;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
          }

          > p {
            font-size: 25px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.18;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
            margin-top: 20px;
          }
        }

        > .quickpay__amount--available {
          padding: 10px 0;
          width: 33.3333333%;
          border-left: 1px dashed rgba(0, 0, 0, 0.2);

          > span {
            font-size: 14px;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.17;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
          }

          > p {
            font-size: 25px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.18;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
            margin-top: 20px;
          }
        }
      }

      > p {
        font-size: 1rem;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
        margin: 30px 0;
      }

      .quickpay__err {
        margin: 15px 0;

        p {
          margin: 0;
          text-align: center;
          text-align: center;
          color: red;
          font-size: 1rem;
          font-style: italic;
        }

        > div {
          padding-bottom: 10px;
          text-align: center;
          text-align: center;
          color: red;
          font-size: 1rem;
          font-style: italic;
        }
      }

      > .quickpay__btn {
        width: 100px;
        height: 40px;
        border-radius: 3px;
        background-color: #5099de;
        font-size: 1rem;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        margin: 30px auto 0 auto;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
      }

      > .quickpay__image {
        width: 20rem;
        margin: 50px auto;
        opacity: 0.4;
      }
    }
  }
}

.flex-end {
  justify-content: flex-end;
}
.virtual-container {
  position: relative;
}

.virtual-card {
  margin-top: 12px;
  margin-bottom: 12px;
  margin-right: 20px;

  p {
    font-size: 0.8rem;
    margin-bottom: 0.075rem;
    margin-bottom: 0;
  }
}

.virtual-card-flex {
  display: flex;
  justify-content: space-around;
  // align-content: center;
}

.virtual-text-block {
  display: block;
}

.virtual-card-heading {
  color: #727272;
  font-size: 0.5rem;
}

.virtual-card-text {
  color: #004262;
  font-weight: 800;
  padding-bottom: 0.5rem;
  font-size: 0.75rem;
}

.success-message {
  background-color: #d1fae5;
  color: #047857; 
  padding: 0.4rem;
  margin-top: 1rem;
  border-radius: 0.5rem;
}

.paynow {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999999;
  overflow: auto;

  > div {
    max-width: 500px;
    padding: 0 10px;
    margin: 50px auto;

    > div {
      background-color: #fff;
      padding: 20px;
      text-align: center;

      > p {
        margin-bottom: 5px;
        text-align: right;

        > span {
          cursor: pointer;
          color: #000;
        }
      }

      > div {
        > .paynow__image {
          width: 40px;
          height: 40px;
          margin: 0 auto 30px auto;
        }

        // > span {
        //   font-size: 16px;
        //   font-weight: normal;
        //   font-style: normal;
        //   font-stretch: normal;
        //   line-height: 1.88;
        //   letter-spacing: normal;
        //   text-align: center;
        //   color: #000000;
        // }

        > .paynow__amount {
          margin-top: 10px;

          > p {
            font-size: 1rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.17;
            letter-spacing: normal;
            text-align: center;
            color: #5099de;

            > span {
              font-size: 1.5rem;
              font-weight: 600;
              font-style: normal;
              font-stretch: normal;
              line-height: 1;
              letter-spacing: normal;
              text-align: center;
              color: #000000;
              margin-top: 10px;
            }
          }
        }

        > .paynow__btn {
          width: 300px;
          margin: 10px auto;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: space-between;
          align-content: center;

          > .paynow__btn--pay {
            width: 45%;
            min-width: 100px;
            height: 40px;
            border-radius: 5px;
            background-color: #5099de;
            font-size: 1rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
            padding-top: 12px;
            cursor: pointer;
          }

          > .paynow__btn--cancel {
            width: 45%;
            height: 40px;
            min-width: 100px;
            border-radius: 5px;
            background-color: #dcdcdc;
            font-size: 1rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
            padding-top: 12px;
            cursor: pointer;
          }

          > .paynow__btn--confirm {
            width: 130px;
            min-width: 100px;
            height: 40px;
            border-radius: 5px;
            background-color: #5099de;
            font-size: 1rem;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
            padding-top: 12px;
            cursor: pointer;
            margin: 0 auto;
          }
        }
      }
    }
  }
}
</style>